import React from "react";
import {FormattedMessage} from "react-intl";
import Button from "../Utils/UI/Button";
import classes from "./styles.module.css";

function PayoutsDetailFilters({onApplyFilters, onSelectFilter, isLoading, filters}) {

    // FIX: обновляем объект фильтров корректно
    const handleChange = (filterName, isChecked) => {
        onSelectFilter(prev => ({
            ...prev,
            [filterName]: isChecked
        }));
    };

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>

                <h6 className={classes.Title}>
                    <FormattedMessage id="PayoutsDetailFilters.title.status" defaultMessage="Статус"/>
                </h6>

                <div className={classes.Column}>

                    {/* Paid */}
                    <div className={classes.CheckboxWrap}>
                        <input
                            id="Payout"
                            type="checkbox"
                            checked={filters.payout}               // FIX
                            onChange={e => handleChange("payout", e.target.checked)}
                        />
                        <label htmlFor="Payout" className={classes.CustomCheckbox}>
                            <div className={classes.Payout}/>
                            <span><FormattedMessage id="PayoutsDetailFilters.status.paid" defaultMessage="Оплачен" /></span>
                        </label>
                    </div>

                    {/* Error */}
                    <div className={classes.CheckboxWrap}>
                        <input
                            id="PayoutDecline"
                            type="checkbox"
                            checked={filters.payoutDecline}       // FIX
                            onChange={e => handleChange("payoutDecline", e.target.checked)}
                        />
                        <label htmlFor="PayoutDecline" className={classes.CustomCheckbox}>
                            <div className={classes.PayoutDecline}/>
                            <span><FormattedMessage id="PayoutsDetailFilters.status.error" defaultMessage="Ошибка" /></span>
                        </label>
                    </div>

                    {/* Deferred */}
                    <div className={classes.CheckboxWrap}>
                        <input
                            id="Created"
                            type="checkbox"
                            checked={filters.created}             // FIX
                            onChange={e => handleChange("created", e.target.checked)}
                        />
                        <label htmlFor="Created" className={classes.CustomCheckbox}>
                            <div className={classes.Created}/>
                            <span><FormattedMessage id="PayoutsDetailFilters.status.delayed" defaultMessage="Отложен" /></span>
                        </label>
                    </div>

                    {/* Filtered */}
                    <div className={classes.CheckboxWrap}>
                        <input
                            id="Filtered"
                            type="checkbox"
                            checked={filters.filtered}            // FIX
                            onChange={e => handleChange("filtered", e.target.checked)}
                        />
                        <label htmlFor="Filtered" className={classes.CustomCheckbox}>
                            <div className={classes.Filtered}/>
                            <span><FormattedMessage id="PayoutsDetailFilters.status.filtered" defaultMessage="Отфильтрован" /></span>
                        </label>
                    </div>

                </div>
            </div>

            <div className={classes.Footer}>
                <Button
                    onClick={onApplyFilters}
                    label="PayoutsDetailFilters.btn.setFilters"
                    icon="filter"
                    isLoading={!isLoading}
                />
            </div>
        </div>
    );
}

export default PayoutsDetailFilters;



// WEBPACK FOOTER //
// ./src/Components/PayoutsDetailFilters/index.js